import { defineMessages } from "react-intl";

export const LanguageManagerMessages = defineMessages({
  entityName: {
    id: "LanguageManager.title",
    defaultMessage: "Languages",
  },
  defaultDescription: {
    id: "LanguageManager.defaultDescription",
    defaultMessage:
      "When you select a language as the default, it will replace the previously selected default language",
  },
  errorLastVisibleLanguage: {
    id: "LanguageManager.errorLastVisibleLanguage",
    defaultMessage:
      "You must have at least one language visible. If you want to hide this language, please make another language visible first.",
  },
});

export const tableHeaderMessages = defineMessages({
  active: {
    id: "app.active",
    defaultMessage: "active",
  },
  primary: {
    id: "app.default",
    defaultMessage: "default",
  },
  name: {
    id: "app.name",
    defaultMessage: "name",
  },
  code: {
    id: "app.code",
    defaultMessage: "code",
  },
  visible: {
    id: "app.visible",
    defaultMessage: "visible",
  },
});
